import { render, staticRenderFns } from "./PaymentMethods.html?vue&type=template&id=4597a437&scoped=true&external"
import script from "./PaymentMethods.js?vue&type=script&lang=js&external"
export * from "./PaymentMethods.js?vue&type=script&lang=js&external"
import style0 from "./PaymentMethods.vue?vue&type=style&index=0&id=4597a437&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4597a437",
  null
  
)

export default component.exports